import axios from './index';

/**
 * APIs（与 OpenAPI 对齐：GET /v1/system-logs、GET /v1/system-logs/biz/{id}）
 */
export function logs(params: LogsParams) {
    return axios<SystemLogsListRes>('/v1/system-logs', {
        method: 'get',
        params,
    });
}

/** 根据业务 ID 获取该系统下的操作记录列表 */
export function logsByBizId(bizId: string, params?: LogsParams) {
    return axios<SystemLogsListRes>(`/v1/system-logs/biz/${bizId}`, {
        method: 'get',
        params,
    });
}

/**
 * Types（与 OpenAPI SystemLog、Page 对齐）
 */
export type LogsParams = {
    page?: number;
    size?: number;
    account_id?: string;
    action?: 'Create' | 'Delete' | 'Export' | 'Login' | 'Logout' | 'Other' | 'Update';
    biz_id?: string;
    ip_fuzzy?: string;
    method?: 'DELETE' | 'PATCH' | 'POST';
    module?: string;
    status?: 'Failure' | 'Init' | 'Success';
    ua_fuzzy?: string;
    start_time?: string;
    end_time?: string;
};

export type LogsResponse = {
    id: string;
    account_id: string;
    action: string;
    biz_id?: string;
    biz_before?: Record<string, unknown>;
    biz_diff?: Record<string, unknown>;
    body?: Record<string, unknown>;
    ip?: string;
    method?: string;
    module?: string;
    path?: string;
    query?: Record<string, unknown>;
    reason?: string;
    status: 'Failure' | 'Init' | 'Success';
    ua?: string;
    created_at: string;
    updated_at?: string;
};

export type SystemLogsListRes = {
    code: number;
    data: LogsResponse[];
    meta: {
        page?: number;
        size?: number;
        total?: number;
        cursor?: string;
        more?: boolean;
    };
    msg: string;
};
